import {
  journalModuleConfigDefault,
  RECORDS_SCHEMA_NAME,
  recordsSchema,
  recordsURL,
} from '@infotech/energy-link-front-core'
import { defaulCrudConfigMaker, CRUDRouteMaker, createFilterQueryHelpers } from '@infotech/crud'
import { IssueLinkFormWidget, IssueLinkViewWidget } from 'components/LinkedEsuzIssue'
import {
  getColumnsConf,
  getFormConfig,
  defaultFormList,
  getViewConfig,
  defaultViewList,
  defaultFormListEdit,
  defaultFilterList,
  getFilterConfig,
  getAllColumns,
} from './fieldsConf'

const { apiActionFetch } = createFilterQueryHelpers({
  entity            : RECORDS_SCHEMA_NAME,
  URL               : recordsURL,
  apiSchema         : recordsSchema,
  fieldsFilterConfig: getFilterConfig(),
})

export const defaultModuleConfig = {
  ...journalModuleConfigDefault.defaultModuleConfig,
  apiActions: {
    ...journalModuleConfigDefault.defaultModuleConfig.apiActions,
    fetch: apiActionFetch,
  },
  getGridConfig: getColumnsConf,
  getFormConfig,
  getViewConfig,
  defaultFormList,
  defaultViewList,
  defaultFormListEdit,
  routing      : {
    ...journalModuleConfigDefault.defaultModuleConfig.routing,
    list: {
      ...journalModuleConfigDefault.defaultModuleConfig.routing.list,
      filter: {
        ...journalModuleConfigDefault.defaultModuleConfig.routing.list.filter,
        defaultFilterList,
        getFilterConfig,
      },
      manageColumns: true,
      getAllColumns,
      pagination   : {
        limitOptions: [
          { label: `20`, value: 20 },
          { label: `50`, value: 50 },
          { label: `100`, value: 100 },
        ],
      },
    },
    read: {
      ...journalModuleConfigDefault.defaultModuleConfig.routing.read,
      rightWidgets: [
        ...journalModuleConfigDefault.defaultModuleConfig.routing.read.rightWidgets,
        IssueLinkViewWidget,
      ],
    },
    create: {
      ...journalModuleConfigDefault.defaultModuleConfig.routing.create,
      widgetComponent: IssueLinkFormWidget,
    },
    edit: {
      ...journalModuleConfigDefault.defaultModuleConfig.routing.edit,
      widgetComponent: IssueLinkFormWidget,
    },
  },
}

export const moduleCrudConfig = (
  moduleConfig = defaultModuleConfig,
  crudPath = journalModuleConfigDefault.CRUD_PATH,
  apiUrl = recordsURL
) => defaulCrudConfigMaker(moduleConfig, crudPath, apiUrl)

export const CRUDRoute = (
  config = moduleCrudConfig(),
  path = journalModuleConfigDefault.CRUD_PATH
) => CRUDRouteMaker(config, path)
